var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-policy-detail',{staticClass:"pt-policy-detail__page",attrs:{"id":_vm.id,"type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }